import { render, staticRenderFns } from "./departedDetail.vue?vue&type=template&id=4062b05d&scoped=true"
import script from "./departedDetail.vue?vue&type=script&lang=js"
export * from "./departedDetail.vue?vue&type=script&lang=js"
import style0 from "./departedDetail.vue?vue&type=style&index=0&id=4062b05d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4062b05d",
  null
  
)

export default component.exports